import { t } from '../../services/i18nService';
import timeUtils from '../../qti/utils/TimeUtils';
import marketplacePropertiesService from '../../services/MarketplacePropertiesService';
import remainingTimeConstants from '../../services/remainingTime/RemainingTimeConstants';

const timeRemainingSelector = {
    selectLastMinute(timeRemaining) {
        return timeRemaining > 0 && timeRemaining <= remainingTimeConstants.MINUTE_MILLISECONDS;
    },

    selectUseAlertRole(timeRemaining) {
        return timeRemaining < (remainingTimeConstants.FINAL_MINUTES + 1) * remainingTimeConstants.MINUTE_MILLISECONDS;
    },

    selectShouldAlertTimeToSR(timeRemaining) {
        const minutesLeft = Math.floor(timeRemaining / remainingTimeConstants.MINUTE_MILLISECONDS);
        // Alert 5 minutes remaining and one minute remaining
        if (minutesLeft === remainingTimeConstants.FINAL_MINUTES || minutesLeft === 0) {
            return true;
        }
        // Alert time remaining with 30 minutes interval
        return Number.isInteger(minutesLeft / 30);
    },

    selectSrOnlyTimeRemainingCaption(shouldAlertTimeToSR, timeRemaining, remainingTimeString, isInfinityCausedByLiveSession) {
        if (!shouldAlertTimeToSR) {
            return null;
        }

        if (timeRemaining === 0) {
            return t('timeRemaining.timedOut');
        }

        const fullMinutesLeft = Math.floor(timeRemaining / remainingTimeConstants.MINUTE_MILLISECONDS);
        switch (fullMinutesLeft) {
        case 0:
            return timeUtils.getTimeRemainingStrings(remainingTimeConstants.MINUTE_MILLISECONDS, false, isInfinityCausedByLiveSession);

        case remainingTimeConstants.FINAL_MINUTES:
            return timeUtils.getTimeRemainingStrings(remainingTimeConstants.FINAL_MINUTES * remainingTimeConstants.MINUTE_MILLISECONDS,
                false, isInfinityCausedByLiveSession);

        default:
            return remainingTimeString;
        }
    },

    selectTimeRemainingCaption(remainingTimePrimaryEndTime, showEndTimePostPrimaryEndTime, timeRemaining,
        showSeconds, isInfinityCausedByLiveSession, remainingTimeString) {
        if (remainingTimePrimaryEndTime === 0) {
            return showEndTimePostPrimaryEndTime
                ? timeUtils.getTimeRemainingStrings(timeRemaining, showSeconds, isInfinityCausedByLiveSession)
                : t('timeRemaining.primaryEndTimeExpired');
        } else if (remainingTimePrimaryEndTime > 0 && remainingTimePrimaryEndTime < 60000) {
            return t('timeRemaining.primaryEndTimeLessThanOneMinute');
        }
        return remainingTimeString;
    },

    selectProps(ownProps) {
        const {
            timeRemaining,
            finalMinutesMode,
            isInfinityCausedByLiveSession,
            remainingTimePrimaryEndTime,
            showEndTimePostPrimaryEndTime,
        } = ownProps;


        const showSeconds = marketplacePropertiesService.showRemainTimeSeconds()
            || (finalMinutesMode && timeRemaining < remainingTimeConstants.FINAL_MINUTES * remainingTimeConstants.MINUTE_MILLISECONDS);

        const remainingTimeString = timeUtils.getTimeRemainingStrings(remainingTimePrimaryEndTime || timeRemaining,
            showSeconds, isInfinityCausedByLiveSession);

        const shouldAlertTimeToSR = this.selectShouldAlertTimeToSR(timeRemaining);

        return {
            lastMinute: this.selectLastMinute(timeRemaining),
            shouldAlertTimeToSR,
            srOnlyTimeRemainingCaption: this.selectSrOnlyTimeRemainingCaption(shouldAlertTimeToSR, timeRemaining, remainingTimeString,
                isInfinityCausedByLiveSession),
            timeRemainingCaption: this.selectTimeRemainingCaption(remainingTimePrimaryEndTime, showEndTimePostPrimaryEndTime, timeRemaining,
                showSeconds, isInfinityCausedByLiveSession, remainingTimeString),
            useAlertRole: this.selectUseAlertRole(timeRemaining),
        };
    },
};

export default timeRemainingSelector;
